import React from 'react';
import {
  Restricted,
  ViewTitle,
  translate as t,
} from 'admin-on-rest';
import References from '../components/References';
import Section from '../components/utils/Section';
import Alias from '../components/Alias';

export const AliasList = (props) => (
  <Restricted authParams={{ route: '/alias' }} location={props.location}>
    <div>
      <ViewTitle title="Alias" />
      <References references={[{ name: 'alias' }]}>
        <Aliases {...props} />
      </References>
    </div>
  </Restricted>
);

export const Aliases = t((props) => (
  <Section>
    <Alias {...props} />
  </Section>
));

